<template>
  <Catalogs
    title="Статусы заказчиков"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'CustomerStatusAdd'"
    :route-edit="'CustomerStatusEdit'"
    :route-view="'CustomerStatusView'"
    :route-path="'/customer_statuses'"
    :can-edit="canEditCustomerStatusCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
   import Catalogs from "../Catalogs.vue";

export default {
  name: "CustomerStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getCustomerStatuses(data);
    },
    canEditCustomerStatusCatalogs() {
      return this.hasPermission([PERM.CATALOG_CUSTOMER_STATUS_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/CustomerStatuses/CustomerStatuses.vue